import React, { useEffect, useState } from 'react';
import { PageHeader, Button } from 'antd';
import { Stack } from '../../types/Stack';
import { Client } from '../../types/Client';
import { StackList, StackListSearchFilters } from '../../components/Stack';
import StackController from '../../controllers/stack.controller';
import ClientController from '../../controllers/client.controller';

const StackListContainer: React.FC = (): React.ReactElement => {
    const [componentStatusFlags, setComponentStatusFlags] = useState<{ isLoadingData: boolean }>({
        isLoadingData: false,
    });

    const [appliedFilters, setAppliedFilters] = useState<any>({});
    const [clients, setClients] = useState<Client[]>([]);

    const [data, setData] = useState<{
        stacks: Stack[] | [];
        pagination: any;
    }>({
        stacks: [],
        pagination: {},
    });

    // @christianjtr : Could be a hook...
    const setFiltersToApply = (filters: any, opts?: { isPaging: boolean }): void => {
        setAppliedFilters((prevAppliedFilters: any) => {
            return opts && opts.isPaging ? { ...prevAppliedFilters, ...filters } : { ...filters };
        });
    };

    const getStacks = async (): Promise<void> => {
        try {
            setComponentStatusFlags({ isLoadingData: true });
            const {
                stacks: stackList,
                _metadata: { pagination },
            } = await StackController.getAllStacks(appliedFilters);

            setData({
                stacks: stackList.map((stack, index) => ({ key: index, ...stack })) as Stack[],
                pagination,
            });
        } finally {
            setComponentStatusFlags({ isLoadingData: false });
        }
    };

    const getInitialData = async (): Promise<void> => {
        try {
            setComponentStatusFlags({ isLoadingData: true });
            const [
                { list: clientList },
                {
                    stacks: stackList,
                    _metadata: { pagination },
                },
            ] = await Promise.all([ClientController.getAllClients(), StackController.getAllStacks(appliedFilters)]);
            setClients(clientList);
            setData({
                stacks: stackList.map((stack, index) => ({ key: index, ...stack })) as Stack[],
                pagination,
            });
        } finally {
            setComponentStatusFlags({ isLoadingData: false });
        }
    };

    useEffect(() => {
        getInitialData();
    }, [appliedFilters]);

    return (
        <>
            <div className="shadow-sm">
                <PageHeader
                    className="site-page-header py-2 justify-content-end"
                    title={<p className="h5 m-0">Stacks</p>}
                    extra={[
                        <Button
                            key="refresh-stack-list"
                            name="btn-refresh-stack-list"
                            id="btn-refresh-stack-list"
                            title="Refresh list"
                            className="d-inline-flex align-items-center"
                            onClick={(): Promise<void> => getStacks()}
                        >
                            Refresh list
                        </Button>,
                    ]}
                />
                <StackListSearchFilters
                    onSetSearchFilters={setFiltersToApply}
                    isLoadingData={componentStatusFlags.isLoadingData}
                    clients={clients}
                />
                <StackList
                    stacks={data.stacks}
                    pagination={data.pagination}
                    onPageChanges={setFiltersToApply}
                    isLoadingData={componentStatusFlags.isLoadingData}
                />
            </div>
        </>
    );
};

export default StackListContainer;
